import React from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button, Tag } from 'antd'
import { FormOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import EventTag from '../TagsPage/EventTag'
import EventInChargeSelect from './EventInChargeSelect'
import AppointmentTypeTag from '../TagsPage/AppointmentTypeTag'

const displayTags = (event) => {
  return event.tags.map((tag) => (<div key={`${event.id}-${tag.id}`}><EventTag tag={tag} type='tag' /></div>))
}

export default function EventListXS ({ events, updateEvent }) {
  const columns = () => [
    {
      width: 30,
      title: t('Admin.EventList.table.inCharge'),
      dataIndex: 'in_charge',
      key: 'in_charge',
      render: (_, o) => <EventInChargeSelect event={o} updateEventData={updateEvent} reduced={true} />
    },
    {
      width: 40,
      title: t('Admin.EventList.table.box'),
      dataIndex: 'box',
      key: 'box',
      sorter: (a, b) => a.box - b.box,
      render: (_, event) => (event.box && <Link to={`/admin/boxes/${event.box.id}/calendar`}>{event.box.name}</Link>)
    },
    {
      width: 25,
      title: t('Admin.EventList.table.appointment_type'),
      dataIndex: 'appointment_type',
      key: 'appointment_type',
      render: (_, o) => o.appointment ? <AppointmentTypeTag appointment={o.appointment} /> : <Tag color='grey' variant='solid'>{t('Admin.Appointment.type.none')}</Tag>
    },
    {
      width: 60,
      title: t('Admin.EventList.table.tag'),
      dataIndex: 'tag',
      key: 'tag',
      render: (_, o) => displayTags(o)
    },
    {
      width: 60,
      title: t('Admin.EventList.table.title'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      width: 10,
      key: 'action',
      render: (_, o) => (<>
        <Link key='edit' to={`/admin/events/${o.id}`}><Button shape="circle" icon={<FormOutlined />} /></Link>
      </>)
    }
  ]

  const rowClassName = (record) => {
    return record.new ? 'new-event' : ''
  }

  return (
    <CustTable
      style={{ height: 'calc(100vh - 290px)' }}
      height={700}
      width={'400px'}
      initColumns={columns()}
      key={'number'}
      className={'xs-events'}
      rowClassName={rowClassName}
      dataSource={events}
      tableLayout={'auto'}
      pagination={{ placement: ['topStart'], defaultPageSize: 12 }}
      horizontalScroll={1000}
    />
  )
}
